import React, { Component } from 'react';

const LEVELS = [
    { key: 'continent', label: 'ทวีป', icon: 'fas fa-globe-asia', api: 'continents', parentKey: null },
    { key: 'country', label: 'ประเทศ', icon: 'fas fa-flag', api: 'countries', parentKey: 'continent' },
    { key: 'region', label: 'ภูมิภาค', icon: 'fas fa-compass', api: 'regions', parentKey: 'country' },
    { key: 'province', label: 'จังหวัด', icon: 'fas fa-map', api: 'provinces', parentKey: 'region' },
    { key: 'district', label: 'สถานที่ / District', icon: 'fas fa-map-marker-alt', api: 'districts', parentKey: 'province' }
];

export class LocationMaster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            breadcrumb: [],
            items: [],
            childCounts: {},
            loading: false,
            search: '',
            editItem: null,
            formTh: '',
            formEn: ''
        };
    }

    componentDidMount() { this.loadLevel(0, null); }

    currentLevel() { return LEVELS[this.state.breadcrumb.length]; }

    async loadLevel(levelIdx, parentItem) {
        var level = LEVELS[levelIdx];
        if (!level) return;
        this.setState({ loading: true, search: '', childCounts: {} });
        try {
            var r = await fetch('api/programplus/' + level.api + '/master');
            var all = r.ok ? await r.json() : [];
            var items = all;
            if (parentItem) {
                if (level.key === 'country') items = all.filter(x => x.continentId === parentItem.id);
                else if (level.key === 'region') items = all.filter(x => x.countryId === parentItem.id);
                else if (level.key === 'province') items = all.filter(x => x.regionId === parentItem.id);
                else if (level.key === 'district') items = all.filter(x => x.provinceId === parentItem.id);
            }
            this.setState({ items, loading: false });

            // Load next-level data to compute child counts
            var nextLevel = LEVELS[levelIdx + 1];
            if (nextLevel) {
                var rc = await fetch('api/programplus/' + nextLevel.api + '/master');
                if (rc.ok) {
                    var children = await rc.json();
                    var counts = {};
                    var parentField = nextLevel.key === 'country' ? 'continentId'
                        : nextLevel.key === 'region' ? 'countryId'
                        : nextLevel.key === 'province' ? 'regionId'
                        : nextLevel.key === 'district' ? 'provinceId' : null;
                    if (parentField) {
                        children.forEach(c => {
                            var pid = c[parentField];
                            counts[pid] = (counts[pid] || 0) + 1;
                        });
                    }
                    this.setState({ childCounts: counts });
                }
            }
        } catch {
            this.setState({ items: [], loading: false });
        }
    }

    drillDown(item) {
        var newBreadcrumb = [...this.state.breadcrumb, item];
        if (newBreadcrumb.length >= LEVELS.length) return;
        this.setState({ breadcrumb: newBreadcrumb }, () => this.loadLevel(newBreadcrumb.length, item));
    }

    goBreadcrumb(idx) {
        var newBreadcrumb = this.state.breadcrumb.slice(0, idx);
        var parentItem = newBreadcrumb.length > 0 ? newBreadcrumb[newBreadcrumb.length - 1] : null;
        this.setState({ breadcrumb: newBreadcrumb }, () => this.loadLevel(newBreadcrumb.length, parentItem));
    }

    openAdd() { this.setState({ editItem: { id: 0 }, formTh: '', formEn: '' }); }
    openEdit(item) { this.setState({ editItem: item, formTh: item.nameTh || '', formEn: item.nameEn || '' }); }
    closeModal() { this.setState({ editItem: null }); }

    async saveItem() {
        var { editItem, formTh, formEn, breadcrumb } = this.state;
        var level = this.currentLevel();
        if (!formTh.trim() && !formEn.trim()) { alert('กรุณากรอกชื่ออย่างน้อย 1 ภาษา'); return; }
        var parentId = breadcrumb.length > 0 ? breadcrumb[breadcrumb.length - 1].id : 0;
        var body = { id: editItem.id || 0, nameTh: formTh.trim(), nameEn: formEn.trim(), parentId };
        try {
            var r = await fetch('api/programplus/' + level.api + '/master', {
                method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
            });
            if (!r.ok) throw new Error('save failed');
            this.closeModal();
            var parent = breadcrumb.length > 0 ? breadcrumb[breadcrumb.length - 1] : null;
            this.loadLevel(breadcrumb.length, parent);
        } catch (e) { alert('บันทึกไม่สำเร็จ: ' + e.message); }
    }

    async deleteItem(item) {
        if (!window.confirm('ต้องการลบ "' + (item.nameTh || item.nameEn || item.name) + '" หรือไม่?')) return;
        var level = this.currentLevel();
        try {
            var r = await fetch('api/programplus/' + level.api + '/master/' + item.id, { method: 'DELETE' });
            if (!r.ok) throw new Error('delete failed');
            var parent = this.state.breadcrumb.length > 0 ? this.state.breadcrumb[this.state.breadcrumb.length - 1] : null;
            this.loadLevel(this.state.breadcrumb.length, parent);
        } catch (e) { alert('ลบไม่สำเร็จ: ' + e.message); }
    }

    getFiltered() {
        var { items, search } = this.state;
        if (!search.trim()) return items;
        var s = search.trim().toLowerCase();
        return items.filter(x => (x.nameTh || '').toLowerCase().includes(s) || (x.nameEn || '').toLowerCase().includes(s) || (x.name || '').toLowerCase().includes(s));
    }

    render() {
        var { breadcrumb, loading, search, editItem, formTh, formEn, childCounts } = this.state;
        var level = this.currentLevel();
        var levelIdx = breadcrumb.length;
        var nextLevel = LEVELS[levelIdx + 1];
        var filtered = this.getFiltered();
        var canDrillDown = breadcrumb.length < LEVELS.length - 1;

        return (
            <div style={{ padding: 20 }}>
                <style>{`
                    .lm-card { background:#fff; border-radius:10px; padding:16px 20px; box-shadow:0 2px 12px rgba(0,0,0,0.06); margin-bottom:16px; }
                    .lm-item { display:flex; align-items:center; justify-content:space-between; padding:12px 16px; border:1px solid #eee; border-radius:8px; margin-bottom:8px; transition:all 0.15s; background:#fff; }
                    .lm-item:hover { border-color:#dc3545; box-shadow:0 2px 8px rgba(220,53,69,0.1); }
                    .lm-item.clickable { cursor:pointer; }
                    .lm-bread { display:flex; flex-wrap:wrap; align-items:center; gap:6px; font-size:14px; margin-bottom:4px; }
                    .lm-bread-item { color:#dc3545; cursor:pointer; font-weight:600; }
                    .lm-bread-item:hover { text-decoration:underline; }
                    .lm-bread-sep { color:#ccc; }
                `}</style>

                <div className="d-flex justify-content-between align-items-center mb-3">
                    <p style={{ margin: 0, fontSize: 13, color: '#888' }}>ทวีป → ประเทศ → ภูมิภาค → จังหวัด → สถานที่</p>
                    <button className="btn btn-danger" onClick={() => this.openAdd()}>
                        <i className="fas fa-plus"></i> เพิ่ม{level.label}
                    </button>
                </div>

                <div className="lm-card">
                    <div className="lm-bread">
                        <span className="lm-bread-item" onClick={() => this.goBreadcrumb(0)}><i className="fas fa-home"></i> ทวีป</span>
                        {breadcrumb.map((b, i) => (
                            <React.Fragment key={i}>
                                <span className="lm-bread-sep">›</span>
                                <span className="lm-bread-item" onClick={() => this.goBreadcrumb(i + 1)}>{b.nameTh || b.nameEn || b.name}</span>
                            </React.Fragment>
                        ))}
                        <span className="lm-bread-sep">›</span>
                        <span style={{ color:'#666' }}><i className={level.icon}></i> {level.label}</span>
                    </div>

                    <div className="input-group mt-3" style={{ maxWidth: 400 }}>
                        <span className="input-group-text" style={{ background:'#fff' }}><i className="fas fa-search" style={{ color:'#aaa' }}></i></span>
                        <input type="text" className="form-control" placeholder={'ค้นหา' + level.label + '...'}
                            value={search} onChange={e => this.setState({ search: e.target.value })} style={{ borderLeft:'none' }} />
                        {search && <button className="btn btn-outline-secondary" onClick={() => this.setState({ search: '' })}><i className="fas fa-times"></i></button>}
                    </div>
                </div>

                {loading ? (
                    <div className="text-center py-5"><div className="spinner-border text-danger"></div></div>
                ) : filtered.length === 0 ? (
                    <div className="text-center py-5" style={{ color:'#bbb' }}>
                        <i className="fas fa-inbox" style={{ fontSize: 48, display:'block', marginBottom:12 }}></i>
                        {search ? 'ไม่พบรายการที่ค้นหา' : 'ยังไม่มีข้อมูล ' + level.label}
                    </div>
                ) : (
                    <div>
                        <div style={{ fontSize:13, color:'#888', marginBottom:8 }}>ทั้งหมด {filtered.length} รายการ</div>
                        {filtered.map(item => {
                            var cnt = childCounts[item.id] || 0;
                            return (
                                <div key={item.id} className={'lm-item ' + (canDrillDown ? 'clickable' : '')}
                                    onClick={canDrillDown ? () => this.drillDown(item) : undefined}>
                                    <div style={{ flex:1, minWidth:0 }}>
                                        <div style={{ fontSize:15, fontWeight:600 }}>
                                            <i className={level.icon} style={{ color:'#dc3545', marginRight:8 }}></i>
                                            {item.nameTh || item.name || '-'}
                                            {item.nameEn && <span style={{ color:'#888', fontWeight:400, marginLeft:8 }}>({item.nameEn})</span>}
                                        </div>
                                    </div>
                                    {nextLevel && (
                                        <span style={{ background:'#f1f3f5', color:'#495057', padding:'4px 12px', borderRadius:20, fontSize:12, fontWeight:600, marginRight:8, whiteSpace:'nowrap' }}>
                                            <i className={nextLevel.icon} style={{ color:'#dc3545', marginRight:4 }}></i>
                                            {cnt} {nextLevel.label}
                                        </span>
                                    )}
                                    <div className="d-flex" style={{ gap: 6 }} onClick={e => e.stopPropagation()}>
                                        <button className="btn btn-outline-primary btn-sm" onClick={() => this.openEdit(item)}><i className="fas fa-edit"></i></button>
                                        <button className="btn btn-outline-danger btn-sm" onClick={() => this.deleteItem(item)}><i className="fas fa-trash"></i></button>
                                        {canDrillDown && <button className="btn btn-outline-secondary btn-sm"><i className="fas fa-chevron-right"></i></button>}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}

                {editItem && (
                    <div style={{ position:'fixed', top:0, left:0, right:0, bottom:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 }} onClick={() => this.closeModal()}>
                        <div style={{ background:'#fff', borderRadius:12, padding:24, width:'90%', maxWidth:500 }} onClick={e => e.stopPropagation()}>
                            <h5 style={{ marginBottom:16 }}>{editItem.id ? 'แก้ไข' : 'เพิ่ม'}{level.label}</h5>
                            <div className="mb-3">
                                <label style={{ fontSize:13, fontWeight:600 }}>ชื่อภาษาไทย</label>
                                <input className="form-control" value={formTh} onChange={e => this.setState({ formTh: e.target.value })} autoFocus />
                            </div>
                            <div className="mb-3">
                                <label style={{ fontSize:13, fontWeight:600 }}>ชื่อภาษาอังกฤษ</label>
                                <input className="form-control" value={formEn} onChange={e => this.setState({ formEn: e.target.value })} />
                            </div>
                            <div className="d-flex justify-content-end" style={{ gap:8 }}>
                                <button className="btn btn-outline-secondary" onClick={() => this.closeModal()}>ยกเลิก</button>
                                <button className="btn btn-danger" onClick={() => this.saveItem()}><i className="fas fa-save"></i> บันทึก</button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
